import * as moment from 'moment';
import publicApiHelper from "../../helpers/publicApiHelper";

export async function checkGeolocation(context) {
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
            context.commit('setGeolocation', {
                latitude: position.coords.latitude,
                longitude: position.coords.longitude
            })
        })
    }
}


export async function signIn (context, user) {
    try {
        context.commit('setLoading', true, {root: true});

        let res = await publicApiHelper.methods.publicApiPost(`/api/backoffice/auth/login`, user)
        res.data["user"] = user.email;
        res.data["logged_at"] = moment().format("Y-MM-DD H:mm:ss");
        res.logged_at = moment().format("Y-MM-DD H:mm:ss");

        context.commit('setUser', res.data);

        let sessionData = {
            date: moment().format("Y-MM-DD H:mm:ss"),
            expires_in: res.data.expires_in
        };

        context.commit('timer/registerNextCloseSession', sessionData, {root: true})

        return res;

    } catch(e) {
        context.commit("authError", e.response.data.message);
        throw e;
    } finally {
        context.commit('setLoading', false, {root: true});
    }
}

export async function checkAuth (context, user) {
    try {
        context.commit('setLoading', true, {root: true});

        let res = await axios.post(`/api/backoffice/login/check`, user);
        if(res.data === false){
            context.commit('setLoading', false, {root: true});
        }
        return res.data;

    } catch(e) {
        context.commit("authError", e.response.data.message);
        throw e;
    } finally {
        context.commit('setLoading', false, {root: true});
    }
}

export async function refreshToken(context, refresh_token) {
    try {
        context.commit('setLoading', true, {root: true});

        let res = await axios.post(`/api/auth/refresh-token`, {
            device_id: this.$cookies.get("device_id"),
        });

        // res.data["user"] = user.email;
        res.data["logged_at"] = moment().format("Y-MM-DD H:mm:ss");
        res.logged_at = moment().format("Y-MM-DD H:mm:ss");
        context.commit('setUser', res.data);

        let sessionData = {
            date: moment().format("Y-MM-DD H:mm:ss"),
            expires_in: res.data.expires_in
        };

        context.commit('timer/registerNextCloseSession', sessionData, {root: true})
        return res;
    } finally {
        context.commit('setLoading', false, {root: true});
    }
}

export async function logout(context) {

    try {
        context.commit('setLoading', true, {root: true});
        context.commit('logout');
        await axios.post(`/api/auth/logout`, {
          device_id: this.$cookies.get("device_id"),
        });
    } catch (e) {

    } finally {
        context.commit('logout');
        context.commit('setLoading', false, {root: true});
    }
}
